import { clsx } from 'clsx';

export const CURSOR_WHEN_DRAGGING = 'grabbing';
const CURSOR_WHEN_NOT_DRAGGING = 'grab';

type Props = {
  isDraggingInProgress: boolean;
  ref: (element: Element | null) => void;
};

export const DragBar = ({ isDraggingInProgress, ref }: Props) => {
  return (
    <div
      ref={ref}
      className={clsx(
        'dragbar d-flex justify-content-center bg-lvl2 text-light w-100 border-bottom border-dark border-opacity-10',
      )}
      style={{
        lineHeight: '12px',
        cursor: isDraggingInProgress ? CURSOR_WHEN_DRAGGING : CURSOR_WHEN_NOT_DRAGGING,
      }}
    >
      <i className="icon icon-sm text-light">drag_handle</i>
    </div>
  );
};
